import React, { Component } from 'react';
import * as d3 from 'd3';

import ChartSpecs from '../data/chart_specs';

import ImgCat from '../images/species/Cat.png'
import ImgOctopus from '../images/species/Octopus.png'
import SpeciesAvatar from '../components/SpeciesAvatar'
import Dialogue from '../components/Dialogue';

var margin = ChartSpecs.chartspecs.margin;

var margin = ChartSpecs.chartspecs.margin;
const species = ChartSpecs.species;
const acnhColors = ChartSpecs.chartspecs.acnhColors;


class VillagerRarity extends Component {
  constructor(props){
      super(props);
      this.svgRef = React.createRef();

      this.allVillagers = this.props.villagers;

      this.state = {
        selectedVillager:'Octopus',
      };


      let selectedVillagers = this.allVillagers.filter(v => v.species === "Cat" || v.species === "Octopus");


      // Creating the clone of the array
      let cloneVillagerData = selectedVillagers.slice(0);

      const cloneVillagerDataArr = selectedVillagers.map(d => ({ ...d}));

      // Extract the array using splice method
      this.selectedVillagers = cloneVillagerDataArr.splice(0,cloneVillagerDataArr.length);


      this.tierNodes = {};

      this.getSpeicesGroup = this.getSpeicesGroup.bind(this);

      this.simulation = d3.forceSimulation(this.selectedVillagers);
      //this.changeChart = this.changeChart.bind(this);
      //this.removeChart = this.removeChart.bind(this);

      this.rangeOptions = species;

      this.selectedVillagerHandler = this.selectedVillagerHandler.bind(this);
   }
   componentDidMount() {
     this.svg = d3.select(this.svgRef.current);

     this.drawCompareChart();

     this.setUpDonutChart();

     this.drawChart();

   }


   setUpVillagerThumbnail(radius){
       //// Create defs elements //////
       var defs = d3.select('#cat-octopus-chart').append("defs");
       //Create wrapper for the clip paths
       var imageWrapper = defs.append("g").attr("class", "image-group-wrapper");
       let selectedVillagers = this.selectedVillagers;

        //Create a circle with an image for villagers
        let defaultImageWrapper = imageWrapper.selectAll(".villager-thumbnail-r-image")
          .data(selectedVillagers)
          .join("pattern")
          .attr("id", d => `villager-thumbnail-r-${d.name}`)
          .attr("class", "thumbnail-image villager-thumbnail-r-image")
          .attr("viewBox", "-0.1 -0.1 1 1")
          .attr("height", "100%")
          .attr("width", "100%")
          .attr('patternContentUnits', 'objectBoundingBox')

       defaultImageWrapper.append("circle")
          .style("opacity", 0.8)
          .style("fill", acnhColors.themeColor)
          .attr("r", radius);
          //.attr("r", radius/2)<path d="M29.5329 48.4861L53.05 0.808941L0.0777125 12.6782L29.5329 48.4861Z"/>

        defaultImageWrapper
          .append("image")
          //.attr("xlink:href", d => d.image_url)
          .attr("xlink:href", function(d,i) {
            return process.env.PUBLIC_URL + `/images/face/face-image-${d.id}.png`
            //return require(`../images/${d}.png`)
          })
          .attr('preserveAspectRatio', 'xMidYMid meet')
          .attr("height", 0.8)
          .attr("width", 0.8);

     }

   drawDonutChart(data, title, selectedV, order){
      let svg = d3.select('#cat-octopus-donut'),
          donutPerRow = 2,
          chartWidth = 360,
          chartHeight = 200;

      let padding = 50,
          innerRadius = chartWidth / (donutPerRow + 4) - 5,
          outerRadius = chartWidth / (donutPerRow + 4);


      // Species Donut Position
      let donutX = chartWidth / (donutPerRow + 2) + order * (outerRadius * 2 + padding),
          donutY = chartHeight / (donutPerRow);



     const arcs = d3
       .pie()
       .sort(null)
       .value(d => d.frequency)
       .padAngle(0.03)(data);

     svg
      .append("g")
      .attr("class", 'rarity-donut')
      .attr("id", `donut-${order}`)
      .attr("transform", `translate(${donutX}, ${donutY})`);

      const chart = svg.select(`#donut-${order}`);

      const label = chart
      .append("g")
      .attr("class", 'rarity-donut')

      label
      .append("text")
      .text('1/35')
      .attr("text-anchor", "middle")
      .attr("transform", `translate(${0}, ${20})`);

      label
      .append("text")
      .text(title)
      .attr("text-anchor", "middle")
      .attr("transform", `translate(${0}, ${0})`);

      label
      .append("text")
      .text(data.length)
      .attr("text-anchor", "middle")
      .attr("transform", `translate(${0}, ${-20})`);

      //const chart = svg.select(`#donut-${order}`);

      const arc = d =>
        d3
          .arc()
          .padAngle(d.padAngle)
          .innerRadius(innerRadius)
          .outerRadius(outerRadius)
          .startAngle(d.startAngle)
          .endAngle(d.endAngle);

      chart
        .selectAll("path")
        .data(arcs)
        .enter()
        .append("path")
        .attr("fill", d => (d.data.name === selectedV)?acnhColors.themeColor:`rgba(124, 201, 195,0.5)`)
        .attr("d", d => arc(d)());

      chart
        .selectAll("g")
        .data(arcs)
        .enter()
        .append("g")
        .filter(d => (d.data.name === selectedV))
        .attr(
          "transform",
          d => `translate(${arc(d).centroid()[0]}, ${arc(d).centroid()[1]})`
        )
        .append("text")
        .text(d => d.data.name)
        .attr("text-anchor", "middle")
        .attr("y", -10)
        .attr(
          "transform",
          d => `rotate(${((d.endAngle + d.startAngle) / Math.PI) * 90})`
        );

   }

   setUpDonutChart(){

     let svg = d3.select('#cat-octopus-donut'),
         selectedVillagers = this.selectedVillagers;


      let villagerDonutData = selectedVillagers.sort((a,b)=>a.species.localeCompare(b.species)).reduce((obj, villager, i) => {
          if (!obj[villager.species]){
            obj[villager.species] = []
          }
          obj[villager.species].push({
            name: villager.name,
            frequency: 1,
            rarity: villager.Rarity,
            species: villager.species
          });
         return obj;
     }, {});

     this.drawDonutChart(villagerDonutData['Cat'], 'Cats', 'Ankha', 0)
     this.drawDonutChart(villagerDonutData['Octopus'], 'Octopi', 'Zucker', 1)

   }

   drawCompareChart(){
     // init plot
     this.simulation.stop();

     let svg = d3.select('#cat-octopus-chart'),
         chartWidth = 360,
         radius = 8,
         chartHeight = 200,
         selectedVillagers = this.selectedVillagers;

     this.setUpVillagerThumbnail(radius);

     let svgVillagerNode = svg.selectAll('.node');

     // Species Node Position
     let speciesPerRow = 2,
         speciesRowWidth = chartWidth / (speciesPerRow + 0.5);

     let selectedVillagerSpeciesNodes = selectedVillagers.sort((a,b)=>a.species.localeCompare(b.species)).reduce((obj, villager, i) => {
         let uniqueCount = Object.keys(obj).length;
         if (obj[villager.species]){
             ++obj[villager.species].count;
         } else {
           obj[villager.species] = {
             id: i+1,
             species: villager.species,
             count: 1,
             x: (uniqueCount % speciesPerRow + 0.7) * speciesRowWidth,
             y: (Math.floor(uniqueCount / speciesPerRow) + 0.6) * speciesRowWidth,
           };
           uniqueCount++
         }
        return obj;
      }, {});

      //assign position
      selectedVillagers.forEach((villager) => {
         var speciesNode = selectedVillagerSpeciesNodes[villager.species];

         villager.sX = speciesNode.x;
         villager.sY = speciesNode.y;

       });

     svgVillagerNode.data(selectedVillagers)
        .join("circle")
        .classed('node', true)
        //.transition().duration(300)
        .attr("name", d => d.name)
        .attr("r", function(d) {
          let r = radius;
          if(d.species === 'Octopus'){
            r= Math.sqrt(r*23)*3.14/2
          }
          if(d.name === 'Raymond' || d.name === 'Zucker'){
            return r*1.2
          }else{
            return r;
          }
        })
        .style("fill",function(d) {
          if(d.name === 'Raymond' || d.name === 'Zucker'){
            return `url(#villager-thumbnail-r-${d.name})`;
          }else{
            return `url(#villager-species-${d.species})`;
            //return `rgba(124, 201, 195,0.6)`;
          }
        });



        this.simulation.on('tick', function() {
                 svg.selectAll('.node')
                 	  .attr('cx', function(d) { return d.x; })
                 	  .attr('cy', function(d) { return d.y; })
                  //.attr("transform", function(d) { return "translate(" + (d.x) + "," + (d.y) + ")"; })
              })


        let labelNodes = Object.values(selectedVillagerSpeciesNodes);

        svg.selectAll('.villager-label')
            .data(labelNodes)
            .join("g")
            .classed('villager-label', true)
            .append("text")
            .classed('villager-label-text', true)
            .text((d) => `${d.count} ${d.species}`)
            .attr('x', d => d.x - radius*3)
            .attr('y', d => d.y*2 - radius)
            .style('font-size', '0.875rem')

        this.simulation.nodes(selectedVillagers)
                      .force('x', d3.forceX().x(d => d.sX))
                      .force('y', d3.forceY().y(d => d.sY))
                      .force('collide', d3.forceCollide()
                                          .radius(
                                            function(d) {
                                              let r = radius;
                                              if(d.species === 'Octopus'){
                                                r= Math.sqrt(r*23)*3.14/2
                                                return r*1.3
                                              }else{
                                                return r*1.5
                                              }
                                            }
                                          )
                                          .strength(0.5))
                      .alpha(1).restart();



   }

   drawChart(){
     let dataArr = this.getSpeicesGroup();
     var svg = this.svg,
         chartWidth = this.svgRef.current.clientWidth,
         chartHeight = 400,
         barColor = '#017C74',
         barColorLight = '#DEF1F0',
         tooltip = d3.select('#tooltip-rarity'),
         stackKeys = species,
         radius = 40;

     svg.attr("height", chartHeight);
     svg.attr("id", 'rarityChart');

     const formatPercent = d3.format(".2f");
     const xScale= d3.scaleBand()
                  .domain(dataArr.map(d => d.species))
                  .range([margin.left, chartWidth - margin.right])
                  //.range([0, width - margin.right])
                  .padding(0.1);

      const yScale = d3.scaleLinear()
                    .domain([0, d3.max(dataArr, d => parseFloat(d.railty))])
                    //.domain([0, d3.max(dataArr, d => parseFloat(d.railty))]).nice()
                    //.range([margin.top, chartHeight - margin.bottom])
                    .range([chartHeight - margin.top, margin.top]);

     const xAxis = g => g
                 .attr("transform", `translate(0,${chartHeight - margin.top})`)
                 .call(d3.axisBottom(xScale).tickFormat((interval,i) => {
                  return (i%34 !== 0)  ? " ": interval;
                 }).tickSizeOuter(0))
                 .call(g => g.selectAll(".domain").remove());

     const yAxis = g => g
               .attr("transform", `translate(${margin.left},0)`)
               .call(d3.axisLeft(yScale).tickSizeOuter(0).tickFormat(x => `${x}%`))
               .call(g => g.selectAll(".domain").remove())

     let lineGenerator = d3.line()
                           .x(d => xScale(d.species))
                           .y(d => yScale(parseFloat(d.railty)))
                           .curve(d3.curveMonotoneX);

     svg.append("g")
     .attr("class", 'xaxis no-tick gap-tick')
     .call(xAxis);

     svg.append("g")
     .call(yAxis);

     let topspecies = ["Bear cub", "Cat", "Deer", "Dog", "Duck", "Eagle","Goat","Horse","Octopus","Penguin","Rabbit","Sheep"," Squirrel","Wolf"]

     svg.append("g")
        .attr("class", "bars")
        .selectAll("rect")
        .data(dataArr)
        .join("rect")
        .attr("role", "presentation")
        .attr("class", "bar")
        //.attr("fill", barColor)
        .attr("fill", d => ((topspecies.findIndex(s => s === d.species))>0)?barColor:barColorLight)
        .attr("x", d => xScale(d.species))
        .attr("y", d => yScale(parseFloat(d.railty)))
        .attr("height", d => yScale(0) - yScale(parseFloat(d.railty)))
        .attr("width", xScale.bandwidth())
        .on("mouseenter", function(e,d) {
           const x = xScale(d.species) - xScale.bandwidth()*2.75;
           const y = yScale(parseFloat(d.railty));

           let thisBar = d3.select(this);

           d3.select('#tooltip-rarity')
                       .transition()
                       .duration(200)
                       .style("display", "block");



          let labelImg = (d.species  === 'Cow' || d.species === 'Bull')?'Bovine':d.species;

              labelImg = (labelImg.indexOf(' ') >= 0)?labelImg.replace(/ /g,"-"):labelImg;


           d3.select('#tooltip-rarity')
             .html(
               `<div class="ballon-tooltip" style="transform: translate(0%, 0%) rotate(45deg); opacity: 1;"><span class="avatar species-avatar">
                    <img style="transform: translate(0%, 0%) rotate(-45deg);" src=${process.env.PUBLIC_URL}/images/species/${labelImg}.png alt="Avatar" />
                </span>
                <span class="ballon-text">${parseFloat(d.railty)}%</span>
                </div>`
             ).style(
                   "transform",
                   `translate(` + `calc( -50% + ${x}px),` + `calc(-100% + ${y}px - 4rem)` + `)`
                 );


          d3.select(this).transition()
                   .duration(350)
                   .style("stroke", barColor)
                   .style("stroke-opacity", 0.5)

         })
         .on('mouseleave', function() {
           d3.select('#tooltip-rarity')
             .transition()
             .duration(200)
             .style("display", "none")

           d3.select(this)
             .transition()
             .style("stroke", 'none')
         })

   }

   getSpeicesGroup(){
     let speciesGroup = {},
         speciesRailtyArr = [];
     speciesGroup = this.allVillagers.reduce((obj, villager, i) => {
         let uniqueCount = Object.keys(obj).length;
         if (obj[villager.species]){
             ++obj[villager.species].count;
         } else {
           obj[villager.species] = {
             id: i+1,
             species: villager.species,
             railty: villager.Rarity,
             count: 1,
           };
           uniqueCount++
         }
        return obj;
      }, {});


      speciesRailtyArr = Object.values(speciesGroup).map((s) => s).sort((a, b) => parseFloat(b.railty) - parseFloat(a.railty));

      return speciesRailtyArr;
   }

   updateChart(selectedVillager){
     var svg = this.svg,
     barColor = '#017C74',
     barColorLight = '#DEF1F0';

     svg.selectAll("rect")
        .attr("fill", d => (d.species === selectedVillager)?barColor:barColorLight)
      //  .
   }

   selectedVillagerHandler(selectedVillager){
     //let selectedVillager = event.target.value;
     this.setState({selectedVillager: selectedVillager});

     this.updateChart(selectedVillager);
   }


  render() {
    return (
      <div ref={this.props.innerRef}  id={`villager-${this.props.step}`} className="step category-gameplay">
        <h2 className="title">Mystery island villager encounters</h2>
        <p className="paragraph">Even when you rely on the random “mystery island” encounters to find villagers, not all villagers are equally likely to appear, according to a <a href="https://gamewith.net/animal-crossing-new-horizons/article/show/17767" className="link" target="_blank">test</a>. Some villagers actually have a lower probability of appearing on mystery islands  - and it all comes down to their species. </p>

        <p className="paragraph">Take Cat and Octopus as an example. Because there are 35 species total, the chances of meeting any cat are the same as the chances of meeting any octopus during a villager hunt: <b>1/35</b>.</p>

        <div className="equation-container">
          <div className="equation">
            <span className="top"><img className='species-icon' alt='Cat icon' src={ImgCat}/></span>
            <span className="bottom">35 total species</span>
          </div>
          <div className ="equation">
            <span>=</span>
          </div>
          <div className="equation">
            <span className="top"><img className='species-icon' alt='Octopus icon' src={ImgOctopus}/></span>
            <span className="bottom">35 total species</span>
          </div>
        </div>


        <p className="paragraph">However, there are only 3 octopi in the game, but 23 cats; your odds of meeting a specific cat, such as Raymond, is significantly lower than your odds of meeting a specific octopus, such as Zucker. </p>

        <div className="">
          <svg id="cat-octopus-chart" width="360"  height="200"></svg>
        </div>

        <p className="paragraph">This means that some villagers actually are “rarer” than others, depending on what species they are. And when you look at the species rarity of the most popular villagers, you can see that many of them belong to “rarer” species.
        </p>

        <p className="paragraph haspointer">All <span className="unique-square unique">species in Tier 1</span> are highlighted here. Hover over the bar to see the  probability.
        </p>

        <div className="svg-wrapper">
          <div id="tooltip-rarity"></div>
          <svg ref={this.svgRef} width="100%"></svg>
        </div>
        <Dialogue title="Summary" type="regular">
          <p className="paragraph">Although it is not a hard-and-fast rule, the most popular villagers tend to be of the "rarer" species; the probability of randomly encountering that individual villager tends to be lower.</p>
        </Dialogue>
      </div>
    )
  }
}

export default VillagerRarity;
